import React, { useEffect, useState } from "react";
import Button from "./form/Button";

const ConsentDialog = ({ open, onContinue }) => {
  const [showDialog, setShowDialog] = useState(false);
  const [accepted, setAccepted] = useState(false);

  useEffect(() => {
    if (open) setShowDialog(true);
  }, [open]);

  const handleAccept = (e) => {
    setAccepted(e.target.checked);
  };

  const handleContinue = () => {
    onContinue(accepted);
    setShowDialog(false);
  };

  return (
    showDialog && (
      <div className="overlay">
        <div className="popup popup--active accept-terms">
          <div className="popup__content">
            <span className="text-md text-md--variant semibold text-neutral-950">
              You're in control, we just need your go-ahead
            </span>
            <p className="paragraph-lg">
              To help you update your details with multiple providers, we'll act
              on your behalf. This requires your permission.
            </p>
          </div>

          <div className="divider"></div>

          <label className="checkbox">
            <input
              type="checkbox"
              id="authorisation"
              onChange={(e) => handleAccept(e)}
              checked={accepted}
            />
            <span className="checkbox__mark"></span>
            <span className="checkbox__text">
              I authorise Quickmove to act on my behalf to update my details
              with selected service providers.
            </span>
          </label>

          <div className="popup__actions">
            <a
              className="paragraph-md text-primary-500"
              href="https://www.quickmove.co.nz/terms-and-conditions"
              target="_blank"
              rel="noopener noreferrer"
            >
              View full consent text in our Terms & Conditions
            </a>
            <Button
              variant="primary"
              disabled={!accepted}
              onClick={handleContinue}
            >
              Continue
            </Button>
          </div>
        </div>
      </div>
    )
  );
};

export default ConsentDialog;
